import {
  PaintBrush,
  GlobeStand,
  Book,
  Flask,
  MaskHappy,
  BezierCurve,
  Lightbulb,
  Translate,
  Cross,
  Atom,
  TestTube,
  Mountains,
  Pi,
  PersonSimpleTaiChi,
  Users,
  Ticket,
  FilmSlate,
  Devices,
  Coffee,
  Dna,
  BookOpenText,
  Planet,
  SoccerBall,
  Dog,
  MusicNotes,
  Palette,
  Scales,
  CastleTurret,
  Factory,
  UsersThree,
  Flag,
  Cpu,
  PencilRuler,
  Buildings,
  Television,
  GameController,
  Robot,
  ForkKnife,
  TShirt,
  HouseLine,
  PuzzlePiece,
  Car,
  Briefcase,
  Gavel,
  Brain,
  Globe,
} from '@phosphor-icons/react';
import type { Icon } from '@phosphor-icons/react';

export const tagIconMapping: Record<string, Icon> = {
  // Level 1 tags mapping (using slug as key) - Categories 2.0 taxonomy
  arts: PaintBrush,
  entertainment: Ticket,
  geography: GlobeStand,
  history: Book,
  lifestyle: Coffee,
  society: UsersThree,
  stem: Flask,

  // Level 2 tags mapping

  // Arts
  'art-history': Palette,
  design: BezierCurve,
  literature: BookOpenText,
  stage: MaskHappy,

  // Entertainment
  'film-and-tv': FilmSlate, // L2 in DB
  movies: FilmSlate, // L3 in DB
  'tv-series': Television, // L3 in DB
  tv: Television, // Kept for safety
  music: MusicNotes,
  gaming: GameController,
  'comics-and-anime': Robot,
  sports: SoccerBall,

  // Geography
  nations: Flag,
  landmarks: Buildings,
  'natural-features': Mountains,

  // History
  'ancient-history': Scales,
  'pre-modern-history': CastleTurret,
  'modern-history': Factory,

  // Lifestyle
  'consumer-tech': Devices,
  food: ForkKnife,
  fashion: TShirt,
  'home-and-garden': HouseLine,
  hobbies: PuzzlePiece,
  wellness: PersonSimpleTaiChi,
  'planes-trains-and-autos': Car,

  // Society
  business: Briefcase,
  'politics-and-law': Gavel,
  philosophy: Lightbulb,
  'religion-and-mythology': Cross,
  psychology: Brain,
  sociology: Users,
  language: Translate,

  // STEM
  animals: Dog,
  computing: Cpu,
  engineering: PencilRuler,
  'human-biology': Dna,
  chemistry: TestTube,
  physics: Atom,
  space: Planet,
  earth: Globe,
  math: Pi,
};
